import {
    CacheType,
    createObservableDataAction,
    IAction,
    IActionContext,
    IActionInput,
    IAny,
    ICreateActionContext,
    IGeneric
} from '@msdyn365-commerce/core';
import { getSelectedProductIdFromActionInput } from '@msdyn365-commerce-modules/retail-actions';
import { RelewiseProductService } from '../services/ProductService';
import { ProductBuyboxData } from '../types/mapped';

export class GetProductBuyboxDataInput implements IActionInput {
    public productOrVariantRecordId?: string;

    public constructor(productOrVariantRecordId: string | undefined) {
        this.productOrVariantRecordId = productOrVariantRecordId;
    }

    public getCacheKey = () => `RelewiseProduct-${this.productOrVariantRecordId ?? ''}`;

    public getCacheObjectType = () => 'RelewiseProduct';

    public dataCacheType = (): CacheType => 'none';
}

const createInput = (inputData: ICreateActionContext<IGeneric<IAny>>): GetProductBuyboxDataInput => {
    const productOrVariantRecordId = getSelectedProductIdFromActionInput(inputData);
    return new GetProductBuyboxDataInput(productOrVariantRecordId);
};

export async function getProductBuyboxData(input: GetProductBuyboxDataInput, ctx: IActionContext): Promise<ProductBuyboxData | undefined> {
    if (!input.productOrVariantRecordId) {
        const message = '[getProductBuyboxData] Missing product RecordId. Cannot make request for PDP data.';
        console.error(message);
        ctx.telemetry.error(message);
        return;
    }

    const productService = new RelewiseProductService(ctx.requestContext, ctx.telemetry);
    return await productService.getProductDetails(input.productOrVariantRecordId);
}

export const getProductBuyboxDataDataAction = createObservableDataAction({
    id: '@msdyn365-commerce-modules/custom/get-product-buybox-data',
    action: <IAction<unknown>>getProductBuyboxData,
    input: createInput
});

export default getProductBuyboxDataDataAction;
